type SeoConfig = {
  title: string,
  description: string,
  path: string,
  ogType?: 'website'|'article',
  ogImage?: string,
  noIndex?: boolean,
  jsonLd?: Record<string, unknown>|Record<string, unknown>[]
}

function getAbsoluteUrl (baseUrl: string, path: string): string {
  const trimmedPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${trimmedPath}`
}

export function useSeo (config: SeoConfig): void {
  const runtime = useRuntimeConfig()
  const env = runtime.public
  const baseUrl = env.PUBLIC_URL.replace(/\/+$/, '')

  const url = getAbsoluteUrl(baseUrl, config.path)
  const image = getAbsoluteUrl(baseUrl, config.ogImage ?? appOgImageUrl)

  if (config.noIndex) {
    useRobotsRule('noindex, nofollow')
  }

  useSeoMeta({
    title: config.title,
    description: config.description,
    keywords: appSeoKeywords.join(', '),
    ogType: config.ogType ?? 'website',
    ogTitle: config.title,
    ogDescription: config.description,
    ogUrl: url,
    ogSiteName: appName,
    ogLocale: 'fr_CH',
    ogImage: image,
    ogImageAlt: `${appName} — ${appTitle}`,
    twitterCard: 'summary_large_image',
    twitterTitle: config.title,
    twitterDescription: config.description,
    twitterImage: image,
    twitterSite: '@livedisplay_pro',
    twitterCreator: '@livedisplay_pro',
    author: companyName,
    applicationName: appName,
    themeColor: '#DC0032'
  })

  const head: Parameters<typeof useHead>[0] = {}

  // A noindex page (error, 404) must not declare a canonical — contradictory signals.
  if (!config.noIndex) {
    head.link = [
      { rel: 'canonical', href: url }
    ]
  }

  if (config.jsonLd) {
    const blocks = Array.isArray(config.jsonLd) ? config.jsonLd : [config.jsonLd]
    head.script = blocks.map(block => ({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(block)
    }))
  }

  useHead(head)
}
